import { RuntimeColorBadge, RuntimeColorDotLabel } from "@/ui-adapters/RuntimeColorBadge";

interface TicketStatusProps {
  labelColor: string;
  description: string;
  variant: "dot" | "filled";
}

export function TicketStatus({ labelColor, description, variant }: TicketStatusProps): React.ReactNode {
  if (variant === "dot") {
    return <RuntimeColorDotLabel color={labelColor}>{description || "-"}</RuntimeColorDotLabel>;
  }

  return <RuntimeColorBadge color={labelColor}>{description || "-"}</RuntimeColorBadge>;
}
